<template>unauthorized</template>

<style scoped lang="scss"></style>
